import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { resolveLandingRoute } from '@/lib/landing'

// Root index route - redirects to search (or, with the Dashboard-default-landing
// flag on, to /dashboard for authenticated members — see src/lib/landing.ts)
export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: ({ context }) => {
    throw redirect({ to: resolveLandingRoute(context.isAuthenticated, '/search') })
  },
  component: () => null,
})
